import React from 'react'
import '../Style/Footer.css'
import { FaInstagram } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa6";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import { FaGithub } from "react-icons/fa";
import { IoIosArrowRoundUp } from "react-icons/io";
import Resume from "../Assets/Piyush_Kumar_Singh_SFE.docx";
function Footer() {
    return (
        <>
            <footer data-scroll-section>


                <div className='Footer'>
                    <div className='footer-icons'>
                        <a href='https://www.instagram.com/ig_6_strings/' target='_blank' rel="noreferrer">
                            <FaInstagram color='black' />
                        </a>
                        <a href='https://www.linkedin.com/in/piyush-kumar-singh-6234141ba' target='_blank' rel="noreferrer">
                            <FaLinkedinIn color='black' />
                        </a>
                        <a href='https://github.com/Piyush2205' target='_blank' rel="noreferrer">

                            <FaGithub color='black' />
                        </a>


                    </div>

                    <div className='footer-div-a'>
                        <a href={Resume} className='footer-a'>
                            {<MdOutlineArrowRightAlt className="arrowright" />}Resume
                        </a>
                        <a href='/project' className='footer-a'>
                            {<MdOutlineArrowRightAlt className="arrowright" />}Pojects
                        </a>
                        <a href='/contact' className='footer-a' >
                            {<MdOutlineArrowRightAlt className="arrowright" />}Contact
                        </a>
                        <a href='/services' className='footer-a' >
                            {<MdOutlineArrowRightAlt className="arrowright" />}Services
                        </a>
                    </div>




                    <a href='#Navbar'>
                        <div className='footer-go-up-div'>
                            <IoIosArrowRoundUp color='black' />

                        </div>
                    </a>

                    <h1 className='footer-h1'>
                        Piyush Kumar

                    </h1>
                    {/* <p>dev.piyush.singh@gmail.com</p> */}
                </div>

            </footer>
            <div className='footer-p-div'>
                <p className='footer-p'>2025 All rights reserved  D&D Piyush Kumar Singh</p>
            </div>
        </>
    )
}


export default Footer